module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('general-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ('delete-account' === _vm.visibleModal),
      expression: "'delete-account' === visibleModal"
    }],
    staticClass: "kp-modal-small",
    on: {
      "close": function($event) {
        _vm.modalClose()
      }
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    slot: "header"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('modal.delete.title')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "help-block",
    slot: "body"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("\n    " + _vm._s(_vm.$t('modal.delete.message')) + "\n  ")]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteAccount();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('modal.delete.confirm')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.modalClose()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('modal.delete.cancel')) + "\n      ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a99e04d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Account/components/DeleteAccount.vue
// module id = 273
// module chunks = 1